import React from 'react'
import {connect} from 'react-redux'
import * as authActions from '../../actions/authActions'
import * as uiActions from '../../actions/uiActions'

import logo from '../../assets/images/logo.png'

import { Flex, Box } from 'reflexbox'

import Paper from 'material-ui/Paper'
import {grey50, grey600} from 'material-ui/styles/colors';
import LoginForm from './LoginForm'
import Snackbar from 'material-ui/Snackbar'

const styles = {
  centered: {
    textAlign: 'center'
  },
  logo: {
    margin: '5em auto 0',
    maxWidth: '80%'
  },
  paper: {
    padding: '2em',
    background: grey50
  },
  lead: {
    color: grey600
  }
}

const LoginPage = (props) => {
  return (
    <Flex justify="center">
      <Box sm={8} md={4} lg={3}>
        <div style={styles.centered}>
          <img src={logo} style={styles.logo} alt="INOVT"/>
          <p style={styles.lead}>Identifique-se para acessar</p>
        </div>
        <Paper zDepth={1} style={styles.paper}>
          <LoginForm onSubmit={props.handleSubmit} isLoading={props.isLoading} />
        </Paper>
      </Box>
      <Snackbar {...props.snackbar} onRequestClose={props.hideSnackbar} />
    </Flex>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    isLoading: state.auth.isAuthenticating,
    snackbar: state.ui.snackbar
  }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
  return {
    handleSubmit: input => dispatch(authActions.login(input)),
    hideSnackbar: () => dispatch(uiActions.hideSnackbar())
  }
};

// Use connect to put them together
export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)



/** WEBPACK FOOTER **
 ** ./src/components/login/LoginPage.js
 **/